import { render, staticRenderFns } from "./FormRL05.vue?vue&type=template&id=4d8df998"
import script from "./FormRL05.vue?vue&type=script&lang=js"
export * from "./FormRL05.vue?vue&type=script&lang=js"
import style0 from "./FormRL05.vue?vue&type=style&index=0&id=4d8df998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports